module.exports = __webpack_public_path__ + "static/media/BolingbrokeEnterprises.b1b5be4a.png";